<template>
  <div class="py-8 px-12">
    <v-radio-group
      v-for="question in questions" :key="`q${question.id}`" :label="question.title"
      dense
      required
      :value="survey[question.id]"
      @change="setCheckbox($event, question)"
      :rules="[rules.requireChoose(question)]"
      :disabled="questionDependencyActive(question) === false"
    >
      <v-radio
        v-for="(answer, idx) in question.answers" :key="`q${question.id}a${idx}`"
        :label="answer.title"
        :value="answer.title"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data: () => ({
    survey: {}
  }),

  computed: {
    step: {
      get() {
        return this.$store.state.meeting.accountOpenStep;
      },
      set(v) {
        this.setAccountOpenStep(v);
      }
    },

    rules() {
      return {
        requireChoose: (question) => v => {
          if (this.questionDependencyActive(question) === false) {
            return true;
          }

          return Boolean(v?.length) || 'Необходимо выбрать один из пунктов'
        }
      }
    },

    questions() {
      return this.$store.getters["meeting/survey_accopen"]?.questions;
    }
  },

  methods: {
    ...mapMutations("meeting", ["setAccountOpenStep"]),

    questionDependencyActive(question) {
      if (question.dependency) {
        const { question_id: depQuestionId, question_answer: depQuestionAnswer } = question.dependency;
        if (this.survey[depQuestionId] !== depQuestionAnswer) return false;
      }

      return true;
    },

    setCheckbox(value, question) {
      const dependedQuestion = this.questions.find((dependedQuestion) => dependedQuestion.dependency?.question_id === question.id);
      if (dependedQuestion) {
        this.$delete(this.survey, dependedQuestion.id);
      }

      this.survey[question.id] = value;
      this.$store.commit('meeting/setSurveyAccopenData', Object.assign({}, this.survey));
    }
  }
};
</script>
